import { gql } from 'graphql-request';
import { useQueryApplication } from 'src/graphqlhooks';
import { getNamespaceName } from '../objects/namespaces';
import { useRequestGQLQuery } from './useGraphQLQuery';
import { useQuery } from 'react-query';
import { queryPresets } from 'src/queries/base';
import { offsetFor } from './utilities';
import { chain, filter, flatten, includes, map, pathOr, prop, split } from 'ramda';
import { returnIsNotEmptyOrTrue } from 'src/utilities/hasValue';

export const ADVISORBYPERSONA = `query describeByPersona($persona:String!) {
    advisor_profiles(where: {persona: {_eq: $persona}}) {
        value:first_name
        label:first_name
        name:first_name
        id
        email
        account_id
      }
  }`;

export const REASSIGNCHECK = `query checkReassign($loanId:bigint!) {
  reassign_details(where: {loan_id: {_eq: $loanId}}) {
      name
    }
}`;

export const getAdvisorByPersona = (persona: string) => {
  const { data } = useQueryApplication(ADVISORBYPERSONA, {
    variables: { persona: persona },
  });
  return data;
};


const ADVISOR_PROFILE_BY_NAMESPACE = ` query describeAdvisorProfileByNamespace($namespace: jsonb) {
  advisor_profiles(where: {object_meta: {_contains: $namespace}}) {
    id
    value:first_name
    last_name
    name:first_name
    first_name
    persona
    role:persona
    object_meta
    email
    account_id
    avatar
    license
    gender
  }
}`;

const ADVISOR_PROFILE_BY_USERNAME = `query get_advisor_profiles($object_meta: jsonb, $username: String) {
  advisor_profiles(where: {object_meta: {_contains: $object_meta}, _and: {user_name: {_ilike: $username}}}) {
    id
    
    last_name
    first_name
    persona
    object_meta
    email
    account_id
    avatar
    license
    gender
    address
    phone
  }
}`;


const GET_ADVISOR_ACCOUNT_ROLE_BY_USERNAME = gql`query get_advisor_profiles($object_meta: jsonb, $username: String) {
  advisor_profiles(where: {object_meta: {_contains: $object_meta}, _and: {user_name: {_ilike: $username}}}) {
   id
    user_name
    account {
      id
      roles_id
    }
  }

}`;

export const ADVISOR_PROFILE_BY_EMAIL = `query get_advisor_profiles($object_meta: jsonb, $email: String) {
  advisor_profiles(where: {object_meta: {_contains: $object_meta}, _and: {email: {_eq: $email}}}) {
    id
    user_name
    last_name
    first_name
    persona
    object_meta
    type_meta
    email
    account_id
    source_id
    branches
    avatar
    license
    gender
    address
    metadata
    phone,
    status
  }
}`;


const ADVISOR_PROFILE_BY_EMAIL_OR_PERSONA = `query describeAdvisorProfileByEmailOrRoles(
  $emails: [String],
  $rolesId: jsonb,
  $object_meta: jsonb
) {
  advisor_profiles(
    where: {
      _and: [
        {object_meta: {_contains: $object_meta}},
        {_or: [
          {account: {roles_id: {_contains: $rolesId}}},
          {email: {_in: $emails}}
        ]}
      ]
    }
    order_by: { first_name: asc }
  ) {
    id
    user_name
    last_name
    first_name
    persona
    object_meta
    email
    account_id
    avatar
    license
    gender
    address
    metadata
    phone
    account {
      roles_id
    }
  }
}
`;



const ADVISOR_PROFILE_BY_STATE = ` query describeAdvisorProfileByState($address: jsonb,$personas:[String],$object_meta: jsonb) {
  advisor_profiles(where: {_and:[{address: {_contains: $address}},{persona: {_in: $personas}},{object_meta: {_contains: $object_meta}}] }) {
    id
    value:first_name
    last_name
    name:first_name
    first_name
    persona
    role:persona
    object_meta
    email
    account_id
    avatar
    license
    gender
    address
    metadata
  }
}`;

export const QUERY_ADVISOR_PROFILES_BY_PERSONA = `query describeAdvisorProfileByPersonas(
    $personas:[String],
    $object_meta: jsonb) {
      advisor_profiles(where: {_and:[{persona: {_in: $personas}},{object_meta: {_contains: $object_meta}}] }) {
        id
        value:first_name
        last_name
        name:first_name
        user_name
        first_name
        persona
        role:persona
        object_meta
        email
        account_id
        avatar
        license
        gender
        business_name
        address
        metadata
    }
  }`;


export const QUERY_ADVISOR_PROFILES_NOT_IN_PERSONA = `query describeAdvisorProfileExcludingPersonas(
    $personas:[String],
    $object_meta: jsonb) {
      advisor_profiles(where: {_and:[{persona: {_nin: $personas}},{object_meta: {_contains: $object_meta}, account: {status: {_eq: "Active"}}}] }) {
        id
        value:first_name
        last_name
        name:first_name
        user_name
        first_name
        persona
        role:persona
        object_meta
        email
        account_id
        avatar
        license
        gender
        business_name
        address
        metadata,
        account {
          roles_id
        }
    }
  }`;


export const QUERY_ADVISOR_PROFILES = `query getAdvisorProfiles($objectMeta: jsonb, $roles: [String], $statuses: [String]) {
    accounts(where: {object_meta: {_contains: $objectMeta}, roles_id: {_has_keys_any: $roles}, status: {_in: $statuses}}) {
      id
      roles_id
      status
      advisor_profiles {
        id
        value: first_name
        last_name
        name: first_name
        user_name
        first_name
        persona
        role: persona
        object_meta
        email
        account_id
        avatar
        license
        gender
        business_name
        address
        metadata
      }
    }
  }
  `;

export const QUERY_ADVISOR_PROFILES_BY_PERSONA_WITH_PAGINATION = `query AccountsQuery($objectMeta: jsonb!, $roles: [String!]!, $statuses: [String!]!, $limit: Int!, $offset: Int!, $firstname: String!, $lastname: String!)  {
  accounts(limit: $limit, offset: $offset, where: {object_meta: {_contains: $objectMeta}, _not:{roles_id: {_has_keys_any: $roles}}, status: {_in: $statuses}, _or: [{first_name: {_ilike: $firstname}}, {last_name: {_ilike: $lastname}}]  }) {
    id
    roles_id
    status
    advisor_profiles {
      id
      first_name
      last_name
      user_name
      persona
      object_meta
      email
      account_id
      avatar
      license
      gender
      business_name
      address
      metadata
      branches
    }
    first_name
    last_name
  }
  accounts_aggregate (where: {object_meta: {_contains: $objectMeta}, _not:{roles_id: {_has_keys_any: $roles}}, status: {_in: $statuses},_or: [{first_name: {_ilike: $firstname}}, {last_name: {_ilike: $lastname}}] })  {
    aggregate {
      count
    }
  }
}`;

export const GQLGetAdvisorByNamespace = (namespace: string) => {
  const { data, loading } = useQueryApplication(ADVISOR_PROFILE_BY_NAMESPACE, {
    variables: {
      namespace: {
        namespace,
      },
    },
  });
  return { data, loading };
};

export const GQLGetAdvisorByUsername = (username: string) => {
  const { data, loading } = useQueryApplication(ADVISOR_PROFILE_BY_USERNAME, {
    variables: {
      username,
      object_meta: { namespace: getNamespaceName() },
    },
  });
  return { data, loading };
};

export const GQLGetAccountByUsername = (username: string) => {
  const { data, loading } = useQueryApplication(GET_ADVISOR_ACCOUNT_ROLE_BY_USERNAME, {
    variables: {
      username,
      object_meta: { namespace: getNamespaceName() },
    },
  });
  return { data, loading };
};

export const GQLAdvisorAccountByUserName = (variables: any) => {
  const result = useRequestGQLQuery(GET_ADVISOR_ACCOUNT_ROLE_BY_USERNAME, variables);
  return result;
};



export const useGetAdvisorByRolesWithPaginationQuery = (
  roles: string[],
  page: any,
  pageSize: any,
  searchKey: any,
  statuses: string[],
  enabled: boolean = true,
) =>
  useQuery<any, any>(
    ['advisor-by-roles', page, pageSize, searchKey],
    () => GetAdvisorByRolesWithPagination(roles, page, pageSize, searchKey, statuses),
    {
      ...queryPresets.shortLived,
      enabled,
      retry: true,
    }
  );

export const GetAdvisorByRolesWithPagination = async (roles: any, page: any, pageSize: any, searchKey: any, statuses: string[]) => {
  const searchValue = split(' ', searchKey);
  const firstName = searchValue[0];
  const lastName = searchValue[1];
  const result = await useRequestGQLQuery(QUERY_ADVISOR_PROFILES_BY_PERSONA_WITH_PAGINATION, {
    roles: roles,
    objectMeta: { namespace: getNamespaceName() },
    statuses: statuses,
    limit: pageSize,
    offset: offsetFor(page, pageSize),
    firstname: `%${firstName}%`,
    lastname: `%${returnIsNotEmptyOrTrue(
      lastName, lastName, firstName
    )}%`,
  });
  const advisorProfiles = pathOr([], ['accounts'], result);
  const count = pathOr(
    [],
    ['accounts_aggregate', 'aggregate', 'count'],
    result
  );
  const advisorProfileList = chain(prop('advisor_profiles'), advisorProfiles);
  return { advisor_profiles: advisorProfileList, count };
};

export const GQLGetAdvisorByPersona = (
  personas: string[]
) => {
  return useQuery<any, any>(['advisor-by-persona', personas], () => GetAdvisorByPersona(personas), {
    ...queryPresets.oneTimeFetch,
    enabled: true,
    retry: true,
  });
};



export const GQLGetAdvisorProfiles = (
  roles: string[],
  statuses: string[],
) => {
  return useQuery<any, any>(['advisor-by-roles', roles], () => GetAdvisorProfiles(roles, statuses), {
    ...queryPresets.oneTimeFetch,
    enabled: true,
    retry: true,
  });
};

export const GetAdvisorProfiles = async (
  roles: string[],
  statuses: string[]
) => {
  const result = await useRequestGQLQuery(QUERY_ADVISOR_PROFILES, {
    roles: roles,
    objectMeta: { namespace: getNamespaceName() },
    statuses: statuses
  });
  return result
};

export const GetAdvisorByPersona = async (personas: any) => {
  const result = await useRequestGQLQuery(QUERY_ADVISOR_PROFILES_BY_PERSONA, {
    personas: personas,
    object_meta: { namespace: getNamespaceName() },

  });
  return result
};


export const GetAdvisorNotInPersona = async (personas: any) => {
  const result = await useRequestGQLQuery(QUERY_ADVISOR_PROFILES_NOT_IN_PERSONA, {
    personas: personas,
    object_meta: { namespace: getNamespaceName() },

  });
  return result
};
export const GQLGetAdvisorNotInPersona = (
  personas: string[]
) => {
  return useQuery<any, any>(['advisor-not-in-persona', personas], () => GetAdvisorNotInPersona(personas), {
    ...queryPresets.oneTimeFetch,
    enabled: true,
    retry: true,
  });
};


const getAdvisorByEmailAddress = async (email: string) => {
  const result = await useRequestGQLQuery(ADVISOR_PROFILE_BY_EMAIL, {
    email,
    object_meta: { namespace: getNamespaceName() }
  });
  return result
};

const getAdvisorByEmailOrPersonal = async (variables: any) => {
  const result = await useRequestGQLQuery(ADVISOR_PROFILE_BY_EMAIL_OR_PERSONA,variables);
  return result
};

export const GQLGetAdvisorByEmailAddress = (
  email: string
) => {
  return useQuery<any, any>(['advisor-email', email], () => getAdvisorByEmailAddress(email), {
    ...queryPresets.oneTimeFetch,
    enabled: true,
    retry: true,
  });
};





export const GQLGetAdvisorByState = (
  selectedState: string,
  personas: string[]
) => {
  const { data, loading } = useQueryApplication(ADVISOR_PROFILE_BY_STATE, {
    variables: {
      address: { state: selectedState },
      personas: personas,
      object_meta: { namespace: getNamespaceName() },
    },
  });
  return { data, loading };
};



export const GQLGetAdvisorByEmail = (email: string) => {
  const { data, loading } = useQueryApplication(ADVISOR_PROFILE_BY_EMAIL, {
    variables: {
      email,
      object_meta: { namespace: getNamespaceName() }
    },
  });
  return { data, loading };
};

export const GQLGetAdvisorByEmailOrPersona = (
  emails: string[], rolesId: string[] = []
) => {
  const variables = {
    emails,
    object_meta: { namespace: getNamespaceName() },
    rolesId
  }
  return useQuery<any, any>(['advisor-proflies',emails], () => getAdvisorByEmailOrPersonal(variables), {
    ...queryPresets.oneTimeFetch,
    enabled: true,
    retry: true,
  });
};

//describeadvisorbynamespace
//name space will be avalible in object meta data
export const getReassignCheck = (loanId: string) => {
  const { data } = useQueryApplication(REASSIGNCHECK, {
    variables: { loanId: loanId },
  });
  return data;
};


//This method will get all the advisor email that matches with the borrower zipcode
export const groupAdvisorsByEmail = (podConfigs: any) => {
  return flatten(map((config: any) => {
    const assignee = map((assignee: any) => {
      return pathOr("", ["email"], assignee)
    }, pathOr([], ["assignees"], config))
    return assignee;
  }, podConfigs))
}

/**
 * Filters advisor profiles based on matching emails 
 * @param advisorProfiles - Array of advisor profiles to be filtered.
 * @param matchedAdvisorEmails - Array of email addresses to match against.
 * @returns Filtered array of advisor profiles
 */
export const filterAdvisorProfileByZipCode = (advisorProfiles: any, matchedAdvisorEmails: string[]) => {
  return filter((advisorProfile: any) => {
    return includes(pathOr("", ["email"], advisorProfile), matchedAdvisorEmails)
  }, advisorProfiles)
}
